import { IconButton } from "@mui/joy";
import { useRecoilState } from "recoil";
import { layoutAtom } from "recoil/layoutAtom";
import WidthFullIcon from "@mui/icons-material/WidthFull";
import WidthNormalIcon from "@mui/icons-material/WidthNormal";

export default function WidthControlButton() {
  const [layoutState, setLayoutState] = useRecoilState(layoutAtom);
  return (
    <IconButton
      onClick={() => {
        if (layoutState.taskWidth === "full") {
          setLayoutState((state) => ({ ...state, taskWidth: "normal" }));
        } else {
          setLayoutState((state) => ({ ...state, taskWidth: "full" }));
        }
      }}
      variant="plain"
      color="neutral"
      size="sm"
    >
      {layoutState.taskWidth === "full" ? (
        <WidthNormalIcon />
      ) : (
        <WidthFullIcon />
      )}
    </IconButton>
  );
}
